import { carePlanRequestsTyped } from "@/api/(requests)/carePlanTyped";
import type { ModalityTextResponse } from "@/core/types";

export async function getModalityText(patientId: string): Promise<ModalityTextResponse> {
  return carePlanRequestsTyped.get_modality_text({
    context: { showLoader: false },
    patientId,
  });
}
